<template>

  <!--intro/outro modals -->
  <div v-if="!loading">
    <CustomModal :open="outroOpen" v-if="currentAct && currentAct.metas"  width="w-10/12" height="h-5/6" :bg-color="`bg-${currentTheme}-light`"  :bg-image="enquete.cover">
      <div class="evilRed1480:w-6/12 h-full text-center text-yellow-light ml-auto mr-auto flex flex-col justify-around">
        <header>
          <div>
            <h5 class="grand-text">Acte {{currentAct.order + 1}} terminé</h5>
            <h3 class="medium-title mb-10">Bravo !</h3>
            <div class="flex justify-center items-center">
              <p>Vous avez gagné</p>
                <div v-if="localActorScore > 0">
                  <span class="flex font-bariol font-bold text-l text-left text-yellow-medium rounded-md m-2 pr-4 pl-4 pb-3 pt-2 " :class="`bg-${currentTheme}`">
                      <div class="skill-icon h-4 inline mr-3"  v-html="icon('copro')"></div>
                    {{ localActorScore }} points {{$t.scoreoverview.competences_Acteur}}
                 </span>
                </div>
                <div v-if="localQualityScore > 0">
                  <span class=" flex font-bariol font-bold text-l text-left text-yellow-medium rounded-md m-2 pr-4 pl-4 pb-3 pt-2 " :class="`bg-${currentTheme}`">
                      <div class="skill-icon h-4 inline mr-3"  v-html="icon('qualite')"></div>
                      {{ localQualityScore }} points {{$t.scoreoverview.competences_Qualite}}
                 </span>
                </div>
                <div v-if="localLawsScore > 0">
                  <span class="flex font-bariol font-bold text-l text-left text-yellow-medium rounded-md m-2 pr-4 pl-4 pb-3 pt-2 " :class="`bg-${currentTheme}`">
                      <div class="skill-icon h-4 inline mr-3"  v-html="icon('juridique')"></div>
                     {{ localLawsScore }} points {{$t.scoreoverview.competences_Juridique}}
                 </span>
                </div>
            </div>
          </div>
        </header>
        <p class="grand-text max-w-[1100px]">{{currentAct.metas.text_outro}}</p>
        <ShadowButton class="ml-auto mr-auto" :theme="`${currentTheme}-light-yellow`" width="300px" @click="endSequence()">Continuer</ShadowButton>
      </div>
    </CustomModal>
  </div>

  <div v-if="!loading">
    <CustomModal :open="introOpen" v-if="currentAct && currentAct.metas" width="w-10/12" height="h-5/6" :bg-color="`bg-${currentTheme}-light`" :bg-image="enquete.cover">
      <div class="1480:w-6/12 h-full text-center text-yellow-light ml-auto mr-auto flex flex-col justify-around" >
        <header>
          <div>
            <h5 class="grand-text">Acte {{currentAct.order + 1}}</h5>
            <h3 class="medium-title">{{ currentAct.title }}</h3>
            <div class="flex justify-center mt-10">
              <div>
                    <span class="font-bariol font-bold text-l text-left text-yellow-medium rounded-md ml-2 pr-4 pl-4 pb-3 pt-2 mb-2 " :class="`bg-${currentTheme}`">
                      {{ currentAct.metas.duration }} minutes (environ)
                     </span>
              </div>
            </div>
          </div>
        </header>
        <p class="grand-text max-w-[1100px]">{{ currentAct.metas.text_intro }}</p>
        <ShadowButton class="ml-auto mr-auto" width="300px" :theme="`${currentTheme}-light-yellow`" @click="introOpen=false;getNextGame()">C'est parti!</ShadowButton>
      </div>
    </CustomModal>
  </div>


  <!--narrative -->
  <div class="flex" v-if="!loading">
    <CustomModal :fullscreen="true" height="h-screen" width="w-screen" :open="!!narrative" :bgColor="'bg-'+currentTheme+'-light'" :shadow="false" >
      <EnqueteNarrative @nextstep="getNextGame()" slide="top" :narrative="narrative[narrativeIndex]" v-if="narrative"></EnqueteNarrative>
    </CustomModal>
  </div>

  <div class="bg-white" :class="`h-full min-h-screen site-content justify-between flex ${currentTheme}`" v-if="!narrative && !loading">
    <div class="flex w-8/12 flex-col justify-between">
      <header class="mr-4">
        <ShadowButton class="ml-auto mt-4" theme="default-grey" width="50px" @click="closeGame">x</ShadowButton>
      </header>
      <div class="game-container" v-if="currentGame">
        <transition>
          <div class="w-full">
            <div>
              <div>
                <p class="text-left huge-text-bold mb-2 text-dark-midnight-blue">{{currentActivity.instruction}}</p>
                <p class="text-left grand-text text mb-8 text-blue-grey">{{currentActivity.help}}</p>
              </div>
              <component class="game-content" v-if="renderComponent" :is="currentComponent" v-bind="compProperties" @render="forceRerenderComponent" @close="closeGame"></component>
            </div>
          </div>
        </transition>
      </div>
      <div>
        <div :class="`${currentTheme}`">
          <Footer v-if="renderComponent" :activity="currentActivity" :single-activity-mode="singleActivityMode" @action="triggerFooterButton($event)" @result="setResult($event)"></Footer>
        </div>
      </div>
    </div>
    <div v-if="currentAct && !loading" :class="`h-auto w-4/12 1480:w-4/12 bg-${currentTheme}-ultralight`">
      <ExpertModal v-if="videoExpert" :videoExpert="videoExpert" :open="showExpert" @action="triggerFooterButton($event)"></ExpertModal>
      <Sidebar :moduleID="this.currentModule" :theme="currentTheme" :mode="singleActivityMode" :activity="currentActivity" :act="currentAct" @scenarioChange="getNextGame($event)"></Sidebar>
    </div>
  </div>
</template>

<script>

import ActorsSelection from "../../views/games/ActorsSelection";
import QuestionsQCM from "../../views/games/QuestionsQCM";
import DragDropText from "../../views/games/DragDropText";
import DragDrop from "../../views/games/DragDrop";
import YesNo from "../../views/games/YesNo";
import VideoAnswer from "../../views/games/VideoAnswer";
import Photo from "../../views/games/Photo";
import VideoSimpleCard from "../../views/games/VideoSimpleCard";
import VideoRepondeur from "../../views/games/VideoRepondeur";
import CustomModal from "../../components/CustomModal"
import ExpertModal from "../../components/ExpertModal"
import EnqueteNarrative from "../enquete/EnqueteNarrative"
import { mapState } from 'vuex'
import {CourseType,GameType,ScoreType, GameStatus} from '../../constants/game-config'
import Footer from "../../components/games/Footer";
import Sidebar from "../../components/games/Sidebar";
import {parseActivityFromId, parseScenarios,parseAct} from "../../utils/apollo-parser";
import { setScoreActivity, setSequence } from '@/composables/user_log';
import { IsFirstLevelFinished } from '@/composables/user_log';

const icons = {
  juridique: `<svg width="25" height="25" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25.5749 31.2612H10.4021C9.67655 31.262 8.97478 31.5156 8.42127 31.9769C7.86776 32.4382 7.49831 33.0775 7.37847 33.7813H28.5986C28.4787 33.0775 28.1093 32.4382 27.5557 31.9769C27.0022 31.5156 26.3005 31.262 25.5749 31.2612Z" fill="currentColor"/><path d="M37.4118 27.2205L24.5089 14.5257L20.855 18.1194L33.7442 30.8142C34.2415 31.2221 34.8759 31.4323 35.5228 31.4036C36.1697 31.3748 36.7823 31.1092 37.2402 30.6589C37.698 30.2085 37.9681 29.6061 37.9974 28.9698C38.0266 28.3336 37.8128 27.7096 37.3981 27.2205H37.4118Z" fill="currentColor"/><path d="M26.2319 11.4963L19.7051 5.08153C19.6411 5.01792 19.583 4.94876 19.5316 4.8749L11.0316 13.2348C11.1067 13.2854 11.1771 13.3425 11.2417 13.4055L17.7731 19.8248C17.8344 19.8896 17.8908 19.9587 17.9421 20.0314L26.442 11.676C26.3677 11.6212 26.2974 11.5611 26.2319 11.4963Z" fill="currentColor"/><path d="M26.7186 11.0474C26.9408 11.2628 27.2402 11.3835 27.5522 11.3835C27.8641 11.3835 28.1635 11.2628 28.3857 11.0474L29.0206 10.4185C29.1301 10.3109 29.217 10.1831 29.2762 10.0424C29.3355 9.90175 29.366 9.75097 29.366 9.5987C29.366 9.44643 29.3355 9.29565 29.2762 9.15499C29.217 9.01432 29.1301 8.88652 29.0206 8.77888L22.4938 2.34163C22.3846 2.23338 22.2548 2.14746 22.1117 2.08882C21.9687 2.03019 21.8152 2 21.6602 2C21.5052 2 21.3518 2.03019 21.2087 2.08882C21.0656 2.14746 20.9358 2.23338 20.8267 2.34163L20.1918 2.96155C20.0823 3.06918 19.9954 3.19698 19.9361 3.33765C19.8769 3.47832 19.8464 3.62909 19.8464 3.78136C19.8464 3.93363 19.8769 4.08441 19.9361 4.22508C19.9954 4.36575 20.0823 4.49355 20.1918 4.60118L26.7186 11.0474Z" fill="currentColor"/><path d="M10.7628 13.8808C10.6543 13.7723 10.525 13.6862 10.3822 13.6275C10.2394 13.5689 10.0862 13.539 9.9315 13.5394C9.77614 13.5391 9.62226 13.5691 9.47878 13.6277C9.3353 13.6863 9.20508 13.7724 9.09566 13.8808L8.4608 14.5053C8.35128 14.6129 8.26441 14.7407 8.20513 14.8814C8.14586 15.022 8.11535 15.1728 8.11535 15.3251C8.11535 15.4773 8.14586 15.6281 8.20513 15.7688C8.26441 15.9095 8.35128 16.0373 8.4608 16.1449L14.9876 22.5687C15.2098 22.784 15.5092 22.9047 15.8211 22.9047C16.1331 22.9047 16.4325 22.784 16.6547 22.5687L17.2896 21.9398C17.3991 21.8321 17.4859 21.7043 17.5452 21.5637C17.6045 21.423 17.635 21.2722 17.635 21.1199C17.635 20.9677 17.6045 20.8169 17.5452 20.6762C17.4859 20.5356 17.3991 20.4078 17.2896 20.3001L10.7628 13.8808Z" fill="currentColor"/><path d="M30.3681 34.4557H5.60367C4.64792 34.4557 3.73131 34.8291 3.05549 35.4938C2.37967 36.1585 2 37.06 2 38H33.9717C33.9717 37.06 33.592 36.1585 32.9162 35.4938C32.2404 34.8291 31.3238 34.4557 30.3681 34.4557Z" fill="#FFF16F"/></svg>`,
  copro: `<svg width="25" height="25" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 0C12.5523 0 13 0.447715 13 1V18.2105C13 18.7628 12.5523 19.2105 12 19.2105H1C0.447715 19.2105 0 18.7628 0 18.2105V1C0 0.447716 0.447716 0 1 0H12ZM9.09986 14.9078C9.09986 15.4601 9.54757 15.9078 10.0999 15.9078H10.6999C11.2521 15.9078 11.6999 15.4601 11.6999 14.9078V14.2565C11.6999 13.7042 11.2521 13.2565 10.6999 13.2565H10.0999C9.54757 13.2565 9.09986 13.7042 9.09986 14.2565V14.9078ZM9.09986 10.9309C9.09986 11.4832 9.54757 11.9309 10.0999 11.9309H10.6999C11.2521 11.9309 11.6999 11.4832 11.6999 10.9309V10.2796C11.6999 9.7273 11.2521 9.27959 10.6999 9.27959H10.0999C9.54757 9.27959 9.09986 9.7273 9.09986 10.2796V10.9309ZM9.09986 6.95376C9.09986 7.50605 9.54757 7.95376 10.0999 7.95376H10.6999C11.2521 7.95376 11.6999 7.50605 11.6999 6.95376V6.30241C11.6999 5.75013 11.2521 5.30241 10.6999 5.30241H10.0999C9.54757 5.30241 9.09986 5.75013 9.09986 6.30241V6.95376ZM9.09986 2.97688C9.09986 3.52917 9.54757 3.97688 10.0999 3.97688H10.6999C11.2521 3.97688 11.6999 3.52917 11.6999 2.97688V2.32553C11.6999 1.77325 11.2521 1.32553 10.6999 1.32553H10.0999C9.54757 1.32553 9.09986 1.77325 9.09986 2.32553V2.97688ZM5.2 14.9078C5.2 15.4601 5.64772 15.9078 6.2 15.9078H6.8C7.35228 15.9078 7.8 15.4601 7.8 14.9078V14.2565C7.8 13.7042 7.35229 13.2565 6.8 13.2565H6.2C5.64772 13.2565 5.2 13.7042 5.2 14.2565V14.9078ZM5.2 10.9309C5.2 11.4832 5.64772 11.9309 6.2 11.9309H6.8C7.35228 11.9309 7.8 11.4832 7.8 10.9309V10.2796C7.8 9.7273 7.35229 9.27959 6.8 9.27959H6.2C5.64772 9.27959 5.2 9.7273 5.2 10.2796V10.9309ZM5.2 6.95376C5.2 7.50605 5.64772 7.95376 6.2 7.95376H6.8C7.35228 7.95376 7.8 7.50605 7.8 6.95376V6.30241C7.8 5.75013 7.35229 5.30241 6.8 5.30241H6.2C5.64772 5.30241 5.2 5.75013 5.2 6.30241V6.95376ZM5.2 2.97688C5.2 3.52917 5.64772 3.97688 6.2 3.97688H6.8C7.35228 3.97688 7.8 3.52917 7.8 2.97688V2.32553C7.8 1.77325 7.35229 1.32553 6.8 1.32553H6.2C5.64772 1.32553 5.2 1.77325 5.2 2.32553V2.97688ZM1.30015 14.9078C1.30015 15.4601 1.74786 15.9078 2.30015 15.9078H2.90014C3.45243 15.9078 3.90014 15.4601 3.90014 14.9078V14.2565C3.90014 13.7042 3.45243 13.2565 2.90014 13.2565H2.30015C1.74786 13.2565 1.30015 13.7042 1.30015 14.2565V14.9078ZM1.30015 10.9309C1.30015 11.4832 1.74786 11.9309 2.30015 11.9309H2.90014C3.45243 11.9309 3.90014 11.4832 3.90014 10.9309V10.2796C3.90014 9.7273 3.45243 9.27959 2.90014 9.27959H2.30015C1.74786 9.27959 1.30015 9.7273 1.30015 10.2796V10.9309ZM1.30015 6.95376C1.30015 7.50605 1.74786 7.95376 2.30015 7.95376H2.90014C3.45243 7.95376 3.90014 7.50605 3.90014 6.95376V6.30241C3.90014 5.75013 3.45243 5.30241 2.90014 5.30241H2.30015C1.74786 5.30241 1.30015 5.75013 1.30015 6.30241V6.95376ZM1.30015 2.97688C1.30015 3.52917 1.74786 3.97688 2.30015 3.97688H2.90014C3.45243 3.97688 3.90014 3.52917 3.90014 2.97688V2.32553C3.90014 1.77325 3.45243 1.32553 2.90014 1.32553H2.30015C1.74786 1.32553 1.30015 1.77325 1.30015 2.32553V2.97688Z" fill="#FFF16F"/></svg>`,
  qualite: `<svg width="25" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.76696 0H7.83551L6.40377 2.50288L4.76696 0ZM10.1083 0H13.3132L11.7195 2.43714L10.1083 0ZM12.9685 5.13633L10.5499 16.0796L17.9998 5.13633H12.9685ZM-1.25885e-05 5.01449C0.0723541 5.0907 0.171385 5.13642 0.281829 5.13642H5.34364L7.57936 16.1521L0.079979 5.13642L-1.25885e-05 5.01449ZM6.12069 5.13633L8.66873 17.6952C8.70302 17.8743 8.85535 18 9.03819 18H9.04198C9.21719 18 9.37336 17.8781 9.41143 17.7028L12.1918 5.13633H6.12069ZM17.9885 4.37429H12.9966L12.1764 3.13216L14.1112 0.17147C14.1836 0.0647925 14.3017 0 14.4312 0H14.4959C14.614 0 14.7245 0.0571644 14.7968 0.152423L17.9885 4.37429ZM5.78762 3.58338L5.97994 3.24684L3.96869 0.17147C3.89633 0.0647925 3.77826 0 3.64875 0H3.58401C3.46594 0 3.35547 0.0571644 3.28311 0.152423L0.0913937 4.37429H5.33366L5.78762 3.58338ZM6.71866 4.37429H6.2121L6.44824 3.96276L8.60399 0.190517C8.67254 0.0723974 8.79824 0 8.93534 0H8.99248C9.11816 0 9.24004 0.0647925 9.30859 0.17147L11.7233 3.8256L12.0852 4.37429H11.8833H11.3615H6.71866Z" fill="#FFF16F"/></svg>`
};
let steps = []
const components = {Footer, YesNo, VideoRepondeur, VideoAnswer, VideoSimpleCard, ExpertModal, Sidebar, CustomModal, EnqueteNarrative, Photo, DragDrop, DragDropText, ActorsSelection}
export default {
  components,
  data() {
    return {
      introOpen: false,
      outroOpen: false,
      currentScenarioIndex: 0,
      currentStep: undefined,
      currentGame: '',
      lockGame: false,
      correction: false,
      showExpert: false,
      narrative: undefined,
      result: undefined,
      loading: true,
      singleActivityMode: false,
      renderComponent: true,
      narrativeIndex: 0,
      lastActReached: false,
      rattrapage: false,
      scenarioRattrapage: [],
    }
  },

  async mounted(){
    this.$store.dispatch('gamestatus/resetLocalScores')

    const activityId = this.$route.params?.activityId
    if(this.$route.query.r && this.$route.query.r === '1'){
      if (!this.courses || this.courses.length <= 0) {
        await this.$store.dispatch('course/getCourses', this.currentCourseType )
      }
      this.rattrapage = true
      const indexCurrentEnquete = this.courses[0].modules.indexOf(this.courses[0].modules.find((m) => m.id === this.currentModule));
      const currentEnquete = this.courses[0].modules[indexCurrentEnquete]

      const [scenarios] = await parseScenarios(currentEnquete.scenarios, this.moduleId)
      currentEnquete.scenarios = scenarios

      this.scenarioRattrapage = scenarios


      await this.loadRattrapage()
    }
    else if(activityId){
      this.singleActivityMode = true;
      await this.loadActivity(activityId)
    }else{
      await this.loadData()
    }
  },
  computed: {


    ...mapState({
      courses: state => state.course.courses,
      legalScore: state => state.gamestatus.actLawScore,
      actorScore: state => state.gamestatus.actActorScore,
      qualityScore: state => state.gamestatus.actQualityScore,
      currentAct: state => state.enquete.enquete.acts[0],
      missionFinished: state => state.gamestatus.missionFinished,
      enquete: state => state.enquete.enquete,
      currentModule: state => state.gamestatus.currentModule,
      currentSequence: state => state.gamestatus.currentSequence,
      currentCourseType: state => state.gamestatus.currentCourseType,
      currentTheme: state => state.currentTheme,
      localActorScore: state => state.gamestatus.localActorScore,
      localLawsScore: state => state.gamestatus.localLawScore,
      localQualityScore:state => state.gamestatus.localQualityScore ,
      activitiesFinished: state => state.gamestatus.activitiesFinished,
      currentCourse(){ return this.courses[0] },
      scenarios() {
        if(this.rattrapage){

          return [this.scenarioRattrapage]
        }
        else if (!this.currentAct)
          return []

        return this.currentAct.scenarios
      },
        currentActivity() {

        if (!this.currentScenario || !this.currentStep)
          return null

        return this.currentScenario.activities[this.currentStep] || (this.currentScenario.narratives && this.currentScenario.narratives[this.currentStep])
      },
      videoExpert() {
        if (!this.currentActivity || !this.currentActivity.media)
          return null

        const activityMedia = this.currentActivity.media.find(medium => (medium.order == -1))

        return (activityMedia && activityMedia.media)
      },
      currentComponent() {
        if (!this.currentActivity)
          return null

        switch (this.currentActivity.type || this.currentActivity[0].type) {
          case GameType.QCM:
            return QuestionsQCM

          case GameType.ACTORS:
            return ActorsSelection

          case GameType.DRAGDROP:
            return DragDrop

          case GameType.DRAGDROPTEXT:
            return DragDropText

          case GameType.PHOTO:
            return Photo

          case GameType.VIDEOSIMPLECARDS:
            return VideoSimpleCard

          /*case GameType.VIDEOANSWER:
            return VideoAnswer*/

          case GameType.VIDEOINTERACTIVE:
          case GameType.VIDEODEROULEMENTLOCK: {
            if (this.currentActivity.show_correction) {
              return VideoAnswer
            }
            return VideoAnswer
          }

          case GameType.YESNO:
            return YesNo

          case GameType.VIDEOREPONDEUR:
            return VideoRepondeur
        }

        return null
      },
      currentScenario () {
          return this.scenarios[this.currentScenarioIndex]
      },
      compProperties() {
        if (this.currentActivity) {
          return {
            'correction': this.correction,
            'result': this.result,
            'lockGame': this.lockGame,
            'activity': this.currentActivity,
            scenarioId: this.currentScenario.id,
            actId: this.currentAct?.id,
          }
        }
      }
    })
  },
  methods: {
    closeGame() {
      if (this.currentCourseType == CourseType.QUEST) {
        this.$router.push({ name: 'enquete/EnqueteWrapper', params: { noIntro: 'acts' }  })
      } else {
        this.$router.push({ name: 'Home', params: {bypass: 'true'} })
      }
    },
    async loadActivity(activityId){
      this.init(await parseActivityFromId(activityId))

      this.getNextGame()
      this.loading = false;
    },
    async loadRattrapage(){
      await this.$store.dispatch('enquete/getSequence', {id: this.$store.state.gamestatus.currentSequence, moduleId: this.$store.state.gamestatus.currentModule} )
      await this.$store.dispatch('enquete/fakeAct', {actId: this.currentAct.id, scenarios: this.scenarioRattrapage} )
      this.init()
      this.getNextGame()


      this.loading = false;
    },
    endSequence(){
      this.outroOpen=false;
      this.$store.dispatch('gamestatus/addActFinished', this.currentAct.id)

      if (this.currentCourseType == CourseType.QUEST) {
        if (this.lastActReached){
          this.$router.push({ name: 'ScoreOverview'  })
        } else {
          this.$router.push({ name: 'enquete/EnqueteWrapper', params: { noIntro: 'acts' }  })
        }
      } else {
        const bypass = ([...this.$store.state.gamestatus.missionFinished].includes(this.currentModule));
        if(bypass){
          this.$router.push({ name: 'ScoreOverview', params: { isHome: 'true', bypass: bypass }  })
        } else {
          this.$router.push({ name: 'ScoreOverview', params: { isHome: 'true'}  })
        }
        this.$store.dispatch('gamestatus/addMissionFinished',this.$store.state.gamestatus.currentModule )
        // this.$router.push({ name: 'Home' })
      }
    },
    icon(type) {
      return icons[type]
    },
    async loadData(){
      if (!this.courses || this.courses.length <= 0) {
        await this.$store.dispatch('course/getCourses', this.currentCourseType )
      }

      if(this.$store.state.gamestatus.currentSequence){
        await this.$store.dispatch('enquete/getSequence', {id: this.$store.state.gamestatus.currentSequence, moduleId: this.$store.state.gamestatus.currentModule} )
        await this.$store.dispatch('gamestatus/setScoreForAct', {scenarios: this.currentAct.scenarios })
       }
      else
      {
         await this.$store.dispatch('enquete/getModule', this.$store.state.gamestatus.currentModule )
      }
      this.init()

      // Restore theme from module index
      if (this.currentModule && this.currentCourseType == CourseType.QUEST && this.courses && this.courses.length > 0) {
        const moduleIndex = this.courses[0].modules.findIndex(m => (m.id === this.currentModule))
        const indexCurrentEnquete = this.courses[0].modules.indexOf(this.courses[0].modules.find((m) => m.id === this.currentModule));
        const currentEnquete = this.courses[0].modules[indexCurrentEnquete]

        const indexCurrentSequence = currentEnquete.sequences.indexOf(currentEnquete.sequences.find((s) => s.id === this.currentSequence));
        if (currentEnquete.sequences[indexCurrentSequence + 1]) {
          this.lastActReached = false;
        } else {
          this.lastActReached = true;
        }

        if (moduleIndex > -1) {
          const themes = ['blue-quest', 'yellow-quest', 'green-quest', 'pink-quest']
          this.$store.dispatch('setTheme', themes[moduleIndex % themes.length])
        }
      }

      this.introOpen = (this.currentAct.metas.text_intro ? true : false);

      if (!this.introOpen) {
        this.getNextGame()
      }

      this.loading = false;
    },
    init(activity = null){
      steps = []
      if (this.singleActivityMode && activity) {
        let scenarios = [{
          id: '',
          title: activity.title,
          activities: {},
          narratives: {},
          nodes: []
        }]

        scenarios[0].activities[activity.id] = activity

        this.$store.commit('enquete/addAct', {
          id: '',
          title: '',
          order: 0,
          scenarios,
          metas: []
        })
        steps.push(activity.id)
        return
      }

      if (!this.scenarios || this.scenarios.length <= 0) {
        return
      }
      // Aggregate nodes data
      const { nodesById, triggeredNodeIds } = this.scenarios[this.currentScenarioIndex].nodes.reduce((data, node) => {
          data.nodesById[node.id] = node

          node.triggers.forEach(trigger => data.triggeredNodeIds.push(trigger.triggered_node_id))

          return data
      }, {
          nodesById: [],
          triggeredNodeIds: []
      })

      // Get first node and start traveling the nodes tree

      let firstNode = this.scenarios[this.currentScenarioIndex].nodes.find(node => (triggeredNodeIds.indexOf(node.id) < 0 && (node.triggers.length > 0 || this.scenarios[this.currentScenarioIndex].nodes.length == 1)))
      // Safety check for weird case
      if (!firstNode && this.scenarios[this.currentScenarioIndex].nodes.length > 0) {
        firstNode = this.scenarios[this.currentScenarioIndex].nodes[0]
      }

      let currentNode = firstNode

      while (currentNode) {
        steps.push(currentNode.node_content)

        // Got to next node if possible
        if (currentNode.triggers && currentNode.triggers.length > 0) {
            const newCurrentNode = nodesById[currentNode.triggers[0].triggered_node_id]

            // Safe guard for infinite loop
            delete nodesById[currentNode.triggers[0].triggered_node_id]

            currentNode = newCurrentNode
        } else {
            currentNode = null
        }
      }
    },
    triggerFooterButton(val) {
      if(val === 'lockGame'){
        this.lockGame=true;
      }
      else if(val === 'viewResult'){
        this.correction = true;
      } else if (this.videoExpert && !this.showExpert) {
        this.showExpert = true;
      } else if(this.singleActivityMode) {
        this.forceRerenderComponent();
      } else {
        this.getNextGame()
      }
    },
    forceRerenderComponent() {
      this.renderComponent = false;
      this.$store.dispatch('enquete/resetUserAnswers',{ actId: this.compProperties.actId, scenarioId: this.compProperties.scenarioId, activityId: this.compProperties.activity.id})

      this.$nextTick(() => {
        this.renderComponent = true;
        this.reset();
      });
    },
    reset(){
      this.correction = this.lockGame = this.showExpert = this.narrative = this.result = undefined;
      this.currentActivity.userAnswer = []
    },
    setResult(val){
      this.result = val
      this.$store.dispatch('gamestatus/addActivitiesFinished', this.currentStep);
      setScoreActivity(this.currentActivity, val === GameStatus.SUCCESS);
    },
    getScoreType(slug){
      switch(slug) {
        case 'actor':
          return ScoreType.ACTOR
        case 'legal':
          return ScoreType.LAW
        case 'quality':
          return ScoreType.QUALITY
      }
    },
    async getNextGame(scenarioIndex = -1) {
      if (!this.scenarios || this.scenarios.length <= 0) {
        return
      }

      if (!this.rattrapage && (Array.isArray(this.currentActivity) && this.currentActivity[0].type) === GameType.NARRATIVE && this.narrativeIndex < (this.currentActivity.length - 1)) {
        this.narrativeIndex++
        return
      } else {
        this.narrativeIndex = 0
      }
      if( this.currentScenarioIndex === this.scenarios.length - 1 && steps.findIndex(v=> v === this.currentStep) === steps.length-1) {
        const indexCurrentEnquete = this.courses[0].modules.indexOf(this.courses[0].modules.find((m) => m.id === this.currentModule));
        const currentEnquete = this.courses[0].modules[indexCurrentEnquete]
        const indexCurrentSequence = currentEnquete.sequences.indexOf(currentEnquete.sequences.find((s) => s.id === this.currentSequence));
        setSequence(this.currentSequence, 'success');
        if (currentEnquete.sequences[indexCurrentSequence + 1]) {
          setSequence(currentEnquete.sequences[indexCurrentSequence + 1].id);
        }
        this.$store.dispatch('gamestatus/addScenarioFinished', this.scenarios[this.currentScenarioIndex].id)
        this.$store.dispatch('gamestatus/setCurrentScenario', undefined)
        this.narrative = false

        if (this.currentCourseType === CourseType.QUEST){
          if(!this.rattrapage)
            this.outroOpen = true
          else{
            // rattrapage is over
            this.$store.dispatch('gamestatus/setCurrentRattrapageDone', true)
            this.$router.push({ name: 'enquete/EnqueteWrapper', params: { noIntro: 'bravo' }  })
          }
        } else {
          this.endSequence();
        }

      } else if (scenarioIndex === -1) {
        if(steps.findIndex(v=> v === this.currentStep) === steps.length-1){
          this.$store.dispatch('gamestatus/addScenarioFinished', this.scenarios[this.currentScenarioIndex].id)
          this.currentScenarioIndex++;
          this.currentStep = this.currentGame = undefined
          this.init();
        }

        this.currentStep = this.currentStep ?  steps[steps.findIndex(v => v === this.currentStep) + 1] : steps[0]

        this.$store.dispatch('gamestatus/setCurrentScenario', this.scenarios[this.currentScenarioIndex].id)
        this.$store.dispatch('gamestatus/addActivitiesFinished', this.currentStep)

        if (!this.rattrapage && (this.currentActivity.type || this.currentActivity[0].type) === GameType.NARRATIVE){
          this.narrative = this.currentActivity
        }else{
          this.reset()
          this.currentGame = this.currentStep
        }

        // Debug
        // if (Array.isArray(this.currentActivity)) {
        //   console.info([this.currentStep, this.currentActivity[0]?.title, this.currentActivity[0]?.type].join(' - '))
        // } else {
        //   console.info([this.currentActivity?.id, this.currentActivity?.title, this.currentActivity?.type].join(' - '))
        // }
        // console.info(this.currentActivity)
      } else {

        let stepIndex = 0
        this.currentScenarioIndex = scenarioIndex;
        this.init();
        this.currentStep = steps[0];
        this.$store.dispatch('gamestatus/setCurrentScenario', this.scenarios[this.currentScenarioIndex].id)

        while ((this.currentActivity.type || this.currentActivity[0].type) === GameType.NARRATIVE){
          stepIndex++;
          this.currentStep = steps[stepIndex];
        }
        this.reset()
        this.currentGame = this.currentStep
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.bg-midnight-blue-ultralight{
  @apply bg-grey-ultralight
}

.game-container{
  @apply mx-[50px] my-[60px] self-center w-11/12;
  @screen 1024 {
    @apply h-full flex;
    max-width: 900px;
    > div {
      @apply flex flex-col;
      > div {
        @apply my-auto;
      }
    }
  }

}
</style>
